// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wGhz","content":"styles_content__1OGk8"};